export default "__VITE_ASSET__BXUBXfCv__"